<template>
    <div>
        <div class="inner-header ">
            <nav class="navbar fixed-top bg-white animate__animated animate__slideInRight">
                <a @click="$router.go(-1)" class="back-arrow">
                    <svg xmlns="http://www.w3.org/2000/svg" width="17.368" height="16.365" viewBox="0 0 17.368 16.365">
                        <g id="Group_38360" data-name="Group 38360" transform="translate(-27.632 -34.814)" opacity="1">
                            <line id="Line_124" data-name="Line 124" x2="16" transform="translate(29 43)" fill="none" stroke="#000" stroke-width="2" />
                            <path id="Path_51451" data-name="Path 51451" d="M.033,0l-7,7.425L.033,15" transform="translate(35.967 35.5)" fill="none" stroke="#000" stroke-width="2" />
                        </g>
                    </svg>
                </a>
                <a href="javascript:void(0);" class="link-title">New Daily Stand up</a>
                <!-- <router-link :to="{ name: 'Help', params: {  name: 'Campaigns' }}"  class="help-btn1">How To Add<img src="@/assets/play.svg" class="ml-1" alt=""></router-link> -->
            </nav>
        </div>
        <div class="inner-page bg-white animate__animated animate__slideInRight">
            <div class="container-fluid">
                <div class="row">
                    <!-- Enquiry Card -->
                    <div class="col-12">
                        <div class="card details-card form-card">
                            <div class="card-body p-0 mt-2">
                                <div class="row">
                                    <div class="col-12">
                                        <span class="lead-heading mt-4 mb-4">Enter Stand up Meeting Details</span>
                                    </div>
                                    <div class="col-12">
                                        <b-form @submit.prevent="CreateMeeting">
                                            <b-form-group>
                                            <label>Standup Type<span class="text-danger">*</span></label>
                                                <b-form-select v-model="AddDailyMeeting.standup_type" required :options="StandupType">
                                                </b-form-select>
                                            </b-form-group>
                                            <b-form-group v-if="AddDailyMeeting.standup_type=='Outdoor Duty'">
                                                <label>Start Time<span class="text-danger">*</span></label>
                                                <datetime type="datetime" v-model="AddDailyMeeting.start_date" required placeholder="Start Time">
                                                </datetime>
                                            </b-form-group>
                                            <b-form-group v-if="AddDailyMeeting.standup_type=='Outdoor Duty'">
                                            <label>End Time<span class="text-danger">*</span></label>
                                                <datetime type="datetime" v-model="AddDailyMeeting.end_date" required placeholder="End Time">
                                                </datetime>
                                            </b-form-group>
                                            <b-form-group class="form-group  mb-4p-0 ">
                                                <label for="firmName">Meeting Target <span class="text-danger"></span></label>
                                                <b-form-input type="number" v-model="AddDailyMeeting.todays_meeting_target" placeholder=""></b-form-input>
                                            </b-form-group>
                                            <!-- <b-form-group>
                                                <label>Enquiry Sourcing Target<span class="text-danger"></span></label>
                                                <b-form-input type="number" v-model="AddDailyMeeting.enquiry_sourcing_target" placeholder=""></b-form-input>
                                            </b-form-group> -->
                                            <b-form-group>
                                                <label>Sign-in Location<span class="text-danger">*</span></label>
                                                <b-form-input type="text" v-model="AddDailyMeeting.location" disabled readonly required placeholder="Find My Location"></b-form-input>
                                            </b-form-group>
                                          
                                            <b-form-group label="">
                                                <CanmeraImageCapture selfiemessage="Sign in" ref="cameraCapture"/>
                                            </b-form-group>
                                            <b-form-group>
                                                <label>Comments<span class="text-danger">*</span></label>
                                                <b-form-textarea placeholder="Comments" required v-model="AddDailyMeeting.comment" rows="3" max-rows="6"  minlength="50"></b-form-textarea>
                                            </b-form-group>
                                            <b-form-group class="mt-5">
                                                <b-button variant="primary" type="submit" block>Save</b-button>
                                            </b-form-group>
                                        </b-form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { decodeDailyMeetingParams } from '@/assets/scripts/utility.js';
import { Datetime } from 'vue-datetime';
import Multiselect from 'vue-multiselect';
import haversine from 'haversine-distance'


export default {
    name: 'AddMeeting',
    components: {
        datetime: Datetime,
        Multiselect,
        CanmeraImageCapture: () => import('@/components/Forms/CameraImageCapture.vue')
    },
    data() {
        return {
            Campaigns: [],
            ProjectList: [],
            showCampaignModel: false,
            brokerDistanceInKM: null,
            AddCampaign: {
                start_date: null,
                end_date: null,
                campaign_type: null,
                title: null,
                achieved: null,
                enquiries_count: null,
                building_id: null,
                compaign_data: null,
                comment: null,
                executed: false,
                _destroy: false,
                IUD: 'I'
            },
            brokerSelected: {
                id:null,
                name:'Select Broker',
                lat: null,
                long: null
            },
            AddDailyMeeting: {
                todays_meeting_target: 0,
                enquiry_sourcing_target: 0,
                comment: "",
                selfie_photo: "",
                location: "",
                meeting_lat: "",
                meeting_long: "",
                start_date:"",
                end_date:"",
                standup_type:null,
            },
            GetS3Discussion: [{ value: null, text: 'Select One' },
                { value: true, text: 'Yes' },
                { value: false, text: 'No' }
            ]
        }
    },
    created() {
        // let brokers = []
        // this.$store.getters.brokersMaster.forEach(broker => {
        //     brokers.push({ id: broker.value, name: broker.text, lat: broker.lat, long: broker.long })
        // })
        // this.brokers = brokers;
        // this.updateFieldRequired();
        // this.selectBroker();
        this.getCurrentPosition();
    },
    computed: {
        StandupType(){
          return this.$store.getters.standupTypeMaster;
        },
        FieldExecutiveList() {
            return this.$store.getters.FieldExecutiveMaster;
        },
        CamapaignTypes() {
            return this.$store.getters.CampaignTypesMaster;
        },
        firmList() {
            let brokers = []
            this.$store.getters.BrokersFirmNameMaster.forEach(broker => {

                brokers.push({ id: broker.value, name: broker.text, lat: broker.lat, long: broker.long })
            })
            return brokers;
        },
        meetingTypesList(){
            return this.$store.getters.MeetingTypesMaster;
        }
    },
    methods: {
        setEndDate(start_date) {
            this.AddMeeting.end_date_time = start_date
        },
        getCurrentPosition() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    this.AddDailyMeeting.meeting_lat = position.coords.latitude;
                    this.AddDailyMeeting.meeting_long = position.coords.longitude;
                    this.getStreetAddressFrom(position.coords.latitude, position.coords.longitude);
                }, (error) => {
                    console.log(error);
                }, { timeout: 10000, enableHighAccuracy: true, maximumAge: 0 });
            } else {
                //Geolocation is not supported by this browser
            }
        },
        async getStreetAddressFrom(lat, long) {
            try {
                const { data } = await this.$axios.get(
                    "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
                    lat +
                    "," +
                    long +
                    "&key=AIzaSyCDi6loOYUz1fXzMJpqI_83UlcdPrp86Fg"
                );
                if (data.error_message) {
                    console.log(data.error_message)
                } else {
                    this.AddDailyMeeting.location = data.results[0].formatted_address;
                    console.log(this.AddDailyMeeting);
                }
            } catch (error) {
                console.log(error);
            }
        },
        CreateMeeting() {
            this.AddDailyMeeting.selfie_photo = this.$refs.cameraCapture.finalImage;
            if(!this.AddDailyMeeting.selfie_photo){
                this.$refs.cameraCapture.checkPhoto = true;
                return;
            }else{
                this.$refs.cameraCapture.checkPhoto = false;
            }
            // this.AddMeeting.broker_id = this.brokerSelected.id
            let apiParams = decodeDailyMeetingParams(this.AddDailyMeeting);
            this.$axios
                .post("/daily_stand_ups", apiParams,{
                  headers:{'Content-Type': 'multipart/form-data'}
                })
                .then((res) => {
                    this.$refs.cameraCapture.stopCameraStream();
                    this.$store.state.isDailyMeeting = 'yes';
                    swal({
                        title: "Daily Standup Created!",
                        icon: "success",
                    }).then(this.$router.replace({ name: "DailyStandUp" }));
                })
                .catch((err) => {
                    if (err.response.status === 500) {
                        swal({
                            title: "Server Error!",
                            icon: "error",
                        });
                    } else {
                        swal({
                            title: "Error",
                            text: err.response.data.message,
                            icon: "error",
                        });
                    }
                });
        },
    },

}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.bgcolor {
    background: #f58321;
    color: white
}

table {
    font-size: 12px;
    font-weight: 400;
}

.btn-white-small {
    padding: 4px 8px;
    background: #fff;
    border: 1px solid #dfdfdf;
    margin-right: 5px;
}
</style>